export default __webpack_public_path__ + "static/media/tick.89c233cc.svg";